<template>
    <!-- The real Trustpilot asset. Its wordmark is white, so it sits on a dark plate rather than being redrawn in CSS to suit the light band. -->
    <img src="/img/brands/trustpilot.png" alt="Trustpilot" class="h-12 w-auto rounded-md bg-zinc-900 px-3 py-2">
</template>
